import React from "react";
//#region types
import { Grid } from "@mui/material";
//#endregion
//#region components
import { SimpleEntityTitleProps } from "models/propTypes/commonPropTypes";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SimpleEntityTitle: React.FC<SimpleEntityTitleProps> = (props) => {
  const { status, title } = props;
  return (
    <Grid container alignItems="center" spacing={3} className={cssExports.simpleEntityTitleContainer}>
      <Grid item className={cssExports.title}>
        {title}
      </Grid>
      {status ? (
        <Grid item className={cssExports.statusLabelContainer}>
          <label className={clsx(cssExports.statusLabel, cssExports.right)}>{status}</label>
        </Grid>
      ) : (
        ""
      )}
    </Grid>
  );
};

export default SimpleEntityTitle;
